import { Button } from "antd";
import { useNavigate } from "react-router-dom";

function PageNotFoundPage() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: "100vw",
        height: "75vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="shadow-2xl"
        style={{
          width: "30%",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 250,
          fontFamily: "Poppins",
          padding: 20,
          borderRadius: 8.5,
          marginTop: 25,
          paddingLeft: 50,
          paddingRight: 50,
          paddingTop: 22,
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            gap: 12,
          }}
        >
          <div style={{ fontFamily: "Poppins", fontSize: 50 }}>404</div>
          <div style={{ fontFamily: "Poppins", fontSize: 22 }}>
            Page Not Found
          </div>
          <div style={{ textAlign: "center" }}>
            The page you are looking for is not available. Please check the url
            on address bar.
          </div>
          <Button onClick={() => navigate(-1)} type="primary">
            Home
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PageNotFoundPage;
